import { useParams } from 'react-router-dom';
import { CurriculumOverviewTable } from '../../../../../components/Curricula/Tables/CurriculumOverviewTable';

export const CurriculumOverviewSubpage = () => {
  const { curriculumUuid } = useParams();

  return <CurriculumOverviewTable curriculumUuid={curriculumUuid ?? ''} />;
};
